var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.visible)?_c('div',{staticClass:"global-loading"},[_c('div',{staticClass:"loading-box"},[_c('div',{staticClass:"spinner"}),_c('p',[_vm._v(_vm._s(_vm.text))])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }